import {useCallback} from "react"
import {messagesService} from "@dv5/api"

interface UseTableWidgetUpdateProps {
    canvasId: string
    widgetId: string
}

export function useTableWidgetUpdate({canvasId, widgetId}: UseTableWidgetUpdateProps) {
    const updateData = useCallback((patchedPaths: string[], newData: Record<string, unknown>) => {
        messagesService.send('canvas.change-widget-data', {
            canvasId,
            widgetId,
            patchedPaths,
            data: newData,
        })
    }, [canvasId, widgetId])

    return {updateData}
}
